import React from 'react';
import logo from "../../assets/icons/logo.png";
import { Link } from "react-router-dom";


function Expiry() {
    return (
        <div className="loginHolder min-h-[100vh] flex items-center bg-[#F3F4F6]">
            <div className="formHolder bg-white md:w-1/2 lg:w-2/5 max-w-lg mx-auto p-8 rounded-lg shadow text-center">
                <h3 className="text-xl font-bold text-[24px]">Link expired</h3>
                <p>Your Link has expired</p>
                <div className="logo flex justify-center my-8">
                    <img alt="Zimzee" src={logo} />
                </div>
                <div className="flex">
                    <Link className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white" to="/" style={{ margin: "0 auto" }}><span className="savebutton-context">Go to home</span></Link>
                </div>
                {/* <a href="/" type="button" className="button bg-[#FF6600] text-white py-2 px-5 font-bold rounded-[5px] mt-4">Login</a> */}
            </div>
        </div>
    )
}

export default Expiry;